import { P2GStack, P2GText, P2GLink, P2GButton, P2GCard, P2GCardContent } from '@parcel2go/core-ui';
import { useTranslation, Trans } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

export default function Feedback({ feedbackUrl }: { feedbackUrl?: string }) {
  const { t } = useTranslation(TranslationNamespaces.TRACKING);
  return (
    <P2GCard sx={{ height: '100%' }} variant="outlined">
      <P2GCardContent sx={{ height: '100%' }}>
        <P2GStack spacing={2} sx={{ justifyContent: 'space-between', height: '100%' }}>
          <P2GText>
            <Trans
              t={t}
              i18nKey="RESULT_INFORMATION_CARDS_FEEDBACK_TITLE"
              defaults="Rate your experience with Parcel2Go. It takes less than 30 seconds."
            />
          </P2GText>
          <P2GLink href={feedbackUrl} target="_blank" relationship="noopener noreferrer" underline="none">
            <P2GButton variant="tertiary">
              <Trans t={t} i18nKey="RESULT_INFORMATION_CARDS_FEEDBACK_BUTTON" defaults="Leave Feedback" />
            </P2GButton>
          </P2GLink>
        </P2GStack>
      </P2GCardContent>
    </P2GCard>
  );
}
